export default __webpack_public_path__ + "static/media/comparison-DE.768064d1.mp4";